import React from "react"
import { view } from "react-easy-state"
import { Route, Switch, Redirect, withRouter } from "react-router-dom"
import queryString from "query-string"

// import HomePage from 'pages/Home'
import Error404Page from "pages/Error404"

import LtiPage from "pages/Lti"

import LoginPage from "pages/Login"
import RegisterPage from "pages/Register"
import StudentsUsersShowPage from "pages/students/users/Show"
import StudentsCoursesIndexPage from "pages/students/courses/Index"
// import StudentsCoursesShowPage from 'pages/students/courses/Show'
import StudentsSubjectsIndexPage from "pages/students/subjects/Index"
import StudentsChaptersIndexPage from "pages/students/chapters/Index"
import StudentsChaptersShowPage from "pages/students/chapters/Show"
import StudentsVideosShowPage from "pages/students/videos/Show"
import StudentsNotesShowPage from "pages/students/notes/Show"
import StudentsPapersShowPage from "pages/students/papers/Show"
import StudentsPapersEvaluationPage from "pages/students/papers/Evaluation"
import StudentsCoursesPaymentPage from "pages/students/courses/Payment"
import StudentsPapersIndexPage from "pages/students/papers/Index"
// import StudentsQuestionsIndexPage from 'pages/students/questions/Index'
import StudentsQuestionsShowPage from "pages/students/questions/Show"
import StudentsQuestionnairesShowPage from "pages/students/questionnaires/Show"
import StudentsQuestionnairesStartPage from "pages/students/questionnaires/Start"
import StudentsDoubtsIndexPage from "pages/students/doubts/Index"
import StudentsDoubtShowPage from "pages/students/doubts/Show"
import StudentsDoubtsAllPage from "pages/students/doubts/All"

import TeachersDoubtsIndexPage from "pages/teachers/doubts/Index"
import TeachersDoubtsShowPage from "pages/teachers/doubts/Show"

// import StudentsLecturesShowPage from 'pages/students/lectures/Show'

import globalStore from "store"
import PrivateRoute from "routes/PrivateRoute"
import * as AuthHelper from "helpers/auth.helper"
import PricingPage from "pages/PricingPage"

const SPR = (props) => <PrivateRoute loginRoute="/login" {...props} />

const Routes = (props) => {
  const currentPath = props.location.pathname

  const params = queryString.parse(props.location.search)
  if (params && params.token) {
    AuthHelper.setToken(params.token)
    return <Redirect to={currentPath} />
  }

  if (props.location.pathname.startsWith("/courses")) {
    const courseId = props.location.pathname.split("/")[2]

    if (courseId) {
      globalStore.sider.courseId = courseId
    } else {
      delete globalStore.sider.courseId
    }
  }

  return (
    <div style={{ display: "flex", flexDirection: "row" }}>
      <Route path="/">
        <Switch>
          <SPR exact path="/profile" component={StudentsUsersShowPage} />
          <SPR exact path="/courses" component={StudentsCoursesIndexPage} />
          <SPR
            exact
            path="/courses/:courseId/subjects"
            component={StudentsSubjectsIndexPage}
          />
          <SPR
            exact
            path="/subjects/:subjectId/chapters"
            component={StudentsChaptersIndexPage}
          />
          <SPR
            exact
            path="/chapters/:chapterId"
            component={StudentsChaptersShowPage}
          />
          <SPR
            exact
            path="/chapters/:chapterId/videos/:videoId"
            component={StudentsVideosShowPage}
          />
          <SPR
            exact
            path="/chapters/:chapterId/notes/:noteId"
            component={StudentsNotesShowPage}
          />
          <SPR
            exact
            path="/papers/:paperId"
            component={StudentsPapersShowPage}
          />
          <SPR
            exact
            path="/papers/:paperId/evaluation"
            component={StudentsPapersEvaluationPage}
          />
          <SPR
            exact
            path="/courses/:courseId/payment"
            component={StudentsCoursesPaymentPage}
          />
          <SPR
            exact
            path="/courses/:courseId/papers"
            component={StudentsPapersIndexPage}
          />
          <SPR
            exact
            path="/chapters/:chapterId/questionnaires/:questionnaireId"
            component={StudentsQuestionnairesShowPage}
          />
          <SPR
            exact
            path="/chapters/:chapterId/questionnaires/:questionnaireId/start-objective"
            component={StudentsQuestionnairesStartPage}
            extraProps={{ questionType: "objective" }}
          />
          <SPR
            exact
            path="/chapters/:chapterId/questionnaires/:questionnaireId/start-subjective"
            component={StudentsQuestionnairesStartPage}
            extraProps={{ questionType: "subjective" }}
          />
          <SPR
            exact
            path="/chapters/:chapterId/questionnaires/:questionnaireId/questions/:questionId"
            component={StudentsQuestionsShowPage}
          />
          <SPR exact path="/doubts" component={StudentsDoubtsIndexPage} />
          <SPR exact path="/doubts/all" component={StudentsDoubtsAllPage} />
          <SPR
            exact
            path="/doubts/:doubtId"
            component={StudentsDoubtShowPage}
          />
          <SPR
            exact
            path="/teachers/doubts"
            component={TeachersDoubtsIndexPage}
          />
          <SPR
            exact
            path="/teachers/doubts/:doubtId"
            component={TeachersDoubtsShowPage}
          />

          <Route exact path="/login" component={LoginPage} />
          <Route exact path="/register" component={RegisterPage} />
          <Route exact path="/pricing" component={PricingPage} />
          <Route exact path="/pricing/:id" component={PricingPage} />
          <Route exact path="/lti/:jwt" component={LtiPage} />

          <Route exact path="/" render={(props) => <Redirect to="/login" />} />
          {/* <Route exact path="/" component={HomePage} /> */}
          <Route path="/" component={Error404Page} />
        </Switch>
      </Route>
    </div>
  )
}

export default withRouter(view(Routes))
